import * as React from "react";
import { HeadFC, PageProps } from "gatsby";
import Home from "@src/components/page-content/Home/Home";
// import usePageLoad from "@src/hooks/usePageLoad";
import DefaultHead from "@src/lib/Head/DefaultHead";
import { PageContextIntl } from "@src/components/general/WrapPageElement/PageContext";

// markup
const IndexPage = (props: PageProps) => {
  const { path = "/" } = props;
  // usePageLoad();
  return <Home path={path} />;
};

IndexPage.LayoutWrapper = "home";

export default IndexPage;

export const Head: HeadFC<any, PageContextIntl> = (headProps) => {
  return <DefaultHead {...headProps} />;
};
